import React, { useState, ReactNode } from "react";
import { SvgIcon } from "../SvgIcon/SvgIcon";
import { Modal } from "../Modal/Modal";

interface BaseVideoBlockProps {
  body?: string;
  altDescription?: string;
  transcription?: string;
  children: ReactNode;
}

export const VideoContainer: React.FC<BaseVideoBlockProps> = ({
  body,
  altDescription,
  transcription,
  children,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="block-container">
      {body && <div dangerouslySetInnerHTML={{ __html: body }} />}

      <figure className="video-block-container">
        {children}

        {altDescription && (
          <figcaption>
            <button
              onClick={() => setIsModalOpen(true)}
              className="transcription-btn"
            >
              {altDescription}
              <SvgIcon iconName="ic-arrow-right-sm" />
            </button>
          </figcaption>
        )}

        <Modal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          className="video-modal"
          overlayClassName="video-modal-overlay"
        >
          {transcription && (
            <div dangerouslySetInnerHTML={{ __html: transcription }} />
          )}
        </Modal>
      </figure>
    </div>
  );
};
